import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import BrandList from "@/pages/BrandList";
import BrandDetail from "@/pages/BrandDetail";
import RuleList from "@/pages/RuleList";
import RuleAuthor from "@/pages/RuleAuthor";
import RuleDetail from "@/pages/RuleDetail";
import ContentCategories from "@/pages/ContentCategories";
import ContentCategoryDetail from "@/pages/ContentCategoryDetail";
import ContentItemEditor from "@/pages/ContentItemEditor";
import BrandAttributes from "@/pages/BrandAttributes";
import BrandKit from "@/pages/BrandKit";
import BrandPrograms from "@/pages/BrandPrograms";
import DesignRequests from "@/pages/DesignRequests";
import DesignRequestDetail from "@/pages/DesignRequestDetail";
import Approvals from "@/pages/Approvals";
import BlockerInbox from "@/pages/BlockerInbox";
import MyDocuments from "@/pages/MyDocuments";
import LocationDetail from "@/pages/LocationDetail";
import BrandPicker from "@/pages/BrandPicker";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // OAuth callback detection — Emergent normally returns ?#session_id=... in
  // the hash, but some browser referrer-policy configurations strip the
  // fragment and surface it as a query string instead. Detect both.
  const url = window.location.href || "";
  if (location.hash?.includes("session_id=") || url.includes("?session_id=") || location.search?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands"
        element={
          <ProtectedRoute>
            <BrandList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId"
        element={
          <ProtectedRoute>
            <BrandDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/rules"
        element={
          <ProtectedRoute>
            <RuleList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/rules/new"
        element={
          <ProtectedRoute>
            <RuleAuthor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/rules/:ruleId"
        element={
          <ProtectedRoute>
            <RuleDetail />
          </ProtectedRoute>
        }
      />
      <Route path="/rules" element={<ProtectedRoute><BrandPicker section="rules" label="Rules" /></ProtectedRoute>} />
      <Route path="/content" element={<ProtectedRoute><BrandPicker section="content" label="Content & Assets" /></ProtectedRoute>} />
      <Route path="/brand-kit" element={<ProtectedRoute><BrandPicker section="brand-kit" label="Brand Kit" /></ProtectedRoute>} />
      <Route path="/brands/:brandId/brand-kit" element={<ProtectedRoute><BrandKit /></ProtectedRoute>} />
      <Route path="/brand-programs" element={<ProtectedRoute><BrandPicker section="brand-programs" label="Brand Programs" /></ProtectedRoute>} />
      <Route path="/brands/:brandId/brand-programs" element={<ProtectedRoute><BrandPrograms /></ProtectedRoute>} />
      <Route path="/design-requests" element={<ProtectedRoute><BrandPicker section="design-requests" label="Design Requests" /></ProtectedRoute>} />
      <Route path="/brands/:brandId/design-requests" element={<ProtectedRoute><DesignRequests /></ProtectedRoute>} />
      <Route path="/brands/:brandId/design-requests/:designRequestId" element={<ProtectedRoute><DesignRequestDetail /></ProtectedRoute>} />
      <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
      <Route path="/blockers" element={<ProtectedRoute><BlockerInbox /></ProtectedRoute>} />
      <Route path="/my-documents" element={<ProtectedRoute><MyDocuments /></ProtectedRoute>} />
      <Route path="/brands/:brandId/content" element={<ProtectedRoute><ContentCategories /></ProtectedRoute>} />
      <Route path="/brands/:brandId/content/:categoryId" element={<ProtectedRoute><ContentCategoryDetail /></ProtectedRoute>} />
      <Route path="/brands/:brandId/content/:categoryId/items/new" element={<ProtectedRoute><ContentItemEditor /></ProtectedRoute>} />
      <Route path="/brands/:brandId/content-items/:itemId" element={<ProtectedRoute><ContentItemEditor /></ProtectedRoute>} />
      <Route path="/brands/:brandId/attributes" element={<ProtectedRoute><BrandAttributes /></ProtectedRoute>} />
      <Route path="/brands/:brandId/locations/:locationId" element={<ProtectedRoute><LocationDetail /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
